import { useCallback } from 'react';
import useDropdownOptions from 'hooks/useDropdownOptions';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { comparisonOperatorOptions } from '../utils/subscriptionConsts';

const msgComparisonOperatorPrefix = 'push.api.create.settings.comparisonOperator';

export const useComparisonOperators = selectedComparisonOperator => {
    const options = useDropdownOptions(comparisonOperatorOptions, msgComparisonOperatorPrefix);
    const { value: comparisonOperator, onChange: setComparisonOperator } = useFormFieldValue({
        field: selectedComparisonOperator,
    });

    const setComparisonOperatorOnChange = useCallback(
        ({ value: comparisonOperator }) => {
            setComparisonOperator(comparisonOperator);
        },
        [setComparisonOperator]
    );
    return { options, comparisonOperator, setComparisonOperatorOnChange };
};
